import { Components, Theme } from '@mui/material';

import { PrimaryColors } from '../constants';

export const MuiMenu: Components<Theme>['MuiMenu'] = {
  styleOverrides: {
    root: {
      '.MuiList-root': {
        backgroundColor: PrimaryColors.black,
      },
    },
  },
};
